<template>
    <div id="quill-editor" class="quill-editor"></div>
</template>

<script>

import Quill from 'quill';

export default {
    props: {
        value: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            quill: null,
        }
    },
    mounted() {
        this.quill = new Quill('#quill-editor', {
            theme: 'snow',
        });

        this.quill.root.innerHTML = this.value;

        this.quill.on('text-change', () => {
            this.$emit(
                'input',
                this.quill.getText() ? this.quill.root.innerHTML : '',
            );
        });
    },
    methods: {
        setValue(value) {
            this.quill.root.innerHTML = value;
        },
    }
}

</script>
